var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIconForAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon/Back (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2363 17.0974L9.5999 16.461L8.96351 17.0974C9.31498 17.4489 9.88483 17.4489 10.2363 17.0974ZM9.5999 15.1882L5.4363 11.0246C5.08483 10.6732 4.51498 10.6732 4.16351 11.0246C3.81203 11.3761 3.81203 11.9459 4.16351 12.2974L8.96351 17.0974L9.5999 16.461C10.2363 17.0974 10.2362 17.0975 10.2363 17.0974L19.4973 7.8364C19.8488 7.48493 19.8488 6.91508 19.4973 6.56361C19.1458 6.21213 18.576 6.21213 18.2245 6.56361L9.5999 15.1882Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconForAlert);
export default __webpack_public_path__ + "static/media/RightIconForAlert.f667b934d87c4edf96c35817948c0a4b.svg";
export { ForwardRef as ReactComponent };